import { createValidation } from '../../utils/validation';
import { emailTemplateConfig } from './emailTemplateConfig';

// Create validation factory for EmailTemplate entity
const createEmailTemplateValidation = () => {
  return createValidation(emailTemplateConfig.fields);
};

// Export both the factory and a default instance
export const validateEmailTemplateData = createEmailTemplateValidation();
export const createEmailTemplateValidationSchema = createEmailTemplateValidation;
export default createEmailTemplateValidation;

